import { render, staticRenderFns } from "./sofinish.vue?vue&type=template&id=1cd9f17a&scoped=true&"
import script from "./sofinish.vue?vue&type=script&lang=js&"
export * from "./sofinish.vue?vue&type=script&lang=js&"
import style0 from "./sofinish.vue?vue&type=style&index=0&id=1cd9f17a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd9f17a",
  null
  
)

export default component.exports